import CepService from "@/services/CepService";

export const cep = {
  namespaced: true,
  actions: {
    getCep({ commit }, payload) {
      return CepService.GetCep(payload).then(
        (cep) => {
          return Promise.resolve(cep);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
};

export default cep;
